/* ARIELLE v53 – All color images stay visible; thumbnail clicks select the matching Shopify color variant. */
(function(){
  function ready(){
    document.querySelectorAll('[data-ar-gallery]').forEach(function(gallery){
      var thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-ar-thumb]'));
      if(!thumbs.length)return;
      thumbs.forEach(function(thumb){thumb.hidden=false;});
      gallery.removeAttribute('data-ar38-teddy-gallery');
      var form=document.querySelector('.ar-product-v10__details form.ar-product-v10__form');
      var group=form&&Array.prototype.find.call(form.querySelectorAll('[data-ar-option-group]'),function(g){
        return /^(farbe|color|colour)$/i.test(g.getAttribute('data-ar-option-name')||'');
      });
      if(!group)return;
      thumbs.forEach(function(thumb){
        thumb.addEventListener('click',function(){
          var color=thumb.getAttribute('data-ar53-color');
          if(!color)return;
          var choice=Array.prototype.find.call(group.querySelectorAll('[data-ar-choice]'),function(b){
            return b.getAttribute('data-ar-option-value')===color;
          });
          if(!choice||choice.classList.contains('is-selected'))return;
          choice.click();
          requestAnimationFrame(function(){
            var hero=gallery.querySelector('.ar-product-v10__hero-image');
            if(!hero)return;
            hero.src=thumb.getAttribute('data-image-src');
            hero.removeAttribute('srcset');hero.removeAttribute('sizes');
            hero.alt=thumb.getAttribute('data-image-alt')||color;
            thumbs.forEach(function(item){
              var selected=item===thumb;
              item.classList.toggle('is-active',selected);
              item.setAttribute('aria-pressed',selected?'true':'false');
            });
          });
        });
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();